import { Product } from "@/types/types.ts";

export const isTwoManDelivery = (product: Product) => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  return availableOptions.some((option) => option.aliases.dmsId === "26");
};
